import styled from "styled-components";

export const AccountContainer = styled.div`
  position: absolute;
  right: 0;
  box-shadow: 0 4px 8px 3px rgba(0, 0, 0, 0.15), 0 1px 3px rgba(0, 0, 0, 0.3);
  background-color: #fff;
  /* padding: 10px 0; */
  border-radius: 5px;
  z-index: 99;
  top:65px;
  // bottom: -61px;
  hr{
    margin: 0px;
    height: 0.5px;
  }
  .avtar-style{
    display: flex;
    padding: 11px;
    cursor: default;
    span{
      height: 32px;
      width: 32px;
      background: #0a5587;
      border-radius: 50%;
      margin-top: 3px;
      color: #fff;
      font-size: 20px;
      text-align: center;
    }
    .wrapper-div{
      padding-left: 10px;
    }
    .name{
      font-size: 14px;
    }
    .email{
      font-size: 11px;
    }
  }
  .dropdown-menu1 {
    background: #fff;
    min-width: 233px;
    /* position: absolute; */
    top: 100px;
    right: 0;
    list-style: none;
    text-align: start;
    display: block !important;
    font-size: 14px;
    line-height: 1;
    z-index: 2;
    border-radius: 5px;
    /* border: solid 1px #87cdf1; */
    overflow: hidden;
    padding: 0;
    /* padding: 0 10px 0 20px; */
    @media (max-width: 1250px) {
      top: 50px;
    }
  }

  .dropdown-menu1 li {
    background: #fff;
    cursor: pointer;
    color: #08446d;
    border-top: solid 1px #e2e2e2;
    position: relative;
    padding: 10px;
    img.arrow-image {
      display: none;
    }
  }
  .dropdown-menu1 li:first-child {
    border-top: none;
  }

  .dropdown-menu1 li:hover {
    font-weight: bold;
    background: #f7f9fa;
    .arrow-image {
      position: absolute;
      left: -43px;
      top: 8px;
      display: inline-flex;
    }
  }

  .dropdown-menu1.clicked {
    display: none;
  }

  .dropdown-link {
    display: block;
    height: 100%;
    width: 100%;
    text-decoration: none;
    color: #08446d;
    line-height: 2.29;
    text-transform: capitalize;
    font-size: 17px;
    white-space: nowrap;
  }

  @media screen and (max-width: 960px) {
    .fa-caret-down {
      display: none;
    }
  }
`;

export const MenuItemWrapper = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
`;
